<template>
    <v-form ref="form" class="w-100" v-if="item">
        <v-container fluid class="pa-2">
            <v-row dense>
                <v-col class="pr-2">
                    <f-title :title="$t('inb.detail.head.title')" />
                    <v-row dense class="mb-5">
                        <v-col class="pa-0">
                            <c-inb-context
                                :item     = "item"
                                :readonly = "readonly"
                                @morph    = "onMorph"
                                @changed  = "onContext"
                                ref       = "siteselect"
                            />
                        </v-col>
                    </v-row>

                    <f-title
                        title="Wartungsnachweis"
                        class="mt-0"
                    />

                    <v-text-field
                        v-model="item.subject"
                        label="Betreff"
                        class="mt-4"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />

                    <f-date-picker
                        v-model="item.executiondate"
                        label ="inb.maintenance.exedate"
                        :rules="[requiredRule]"
                        :readonly = "readonly"
                        @change   = "onContext"
                    />

                    <v-text-field
                        label          = "Vertragsnummer"
                        v-model        = "item.contractno"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />

                    <v-text-field
                        label          = "Auftragsnummer"
                        v-model        = "item.orderno"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />

                    <v-text-field
                        label="Servicetechniker"
                        v-model="item.technician"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>

                <v-col class="pl-2">
                    <f-title title="Ausgeführte Arbeiten" class="mt-0" />
                    <v-select
                        :items            = "item.units"
                        v-model           = "selected"
                        label             = "Anlage"
                        item-value        = "id"
                        item-text         = "unit.fabricNo"
                        :return-object    = true
                        :readonly         = "readonly"
                        :hide-details     = "true"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="item-selection v-list-item__title">
                                {{ item.unit.fabricNo }}
                            </div>
                        </template>
                    </v-select>

                    <v-textarea
                        v-if="selected"
                        label="Beschreibung"
                        v-model="selected.description"
                        no-resize
                        required
                        rows="15"
                        class="mt-3"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />

                    <v-textarea
                        v-if="selected"
                        label="Ergebnis"
                        v-model="selected.result"
                        no-resize
                        required
                        rows="12"
                        class="mt-3"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
            </v-row>
        </v-container>
    </v-form >
</template>

<script>

import FDatePicker from "@/modules/core/components/utils/FDatePicker";
import FTitle      from "@/modules/core/components/utils/FTitle";
import CInbContext from "@/modules/inb/components/controlls/CInbContext";
import Inb from "@/modules/inb/service/Inb";
import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "CInboxMaintenance",

    props: {
        item: {
            default: function () {
                return {
                    id: null,
                    contractno: null,
                    orderno   : null
                }
            }
        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    components: {
        CInbContext,
        FTitle,
        FDatePicker
    },

    data: () => ({
        selected: null,
    }),

    computed: {
        requiredRule() {
            return Core.rule.required;
        },
    },

    mounted() {
        if (this.item) {
            this.item.incidentType = Inc.type.maintenanceProcess;
        }
    },

    watch: {
        item () {
            this.item.incidentType = Inc.type.maintenanceProcess;
        }
    },

    methods: {
        onSave (success) {
            this.$refs.form.validate();
            Inb.store(this, this.item).then((data) => {
                if (this.$refs.siteselect) {
                    this.$refs.siteselect.closeMenu ();
                }

                if (success) success(data)
            });
        },

        onContext () {
            this.$emit("context", this.item)
        },

        onMorph (event) {
            this.$emit("morph", event)
        },
    }
}
</script>

<style scoped>

</style>